import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/index.vue';
import {
  getToken,
  setToken,
  removeToken,
  getStoreId,
  setStoreId,
  removeStoreId,
  setUserInfo,
  getUserInfo,
  removeUserInfo
} from '@/utils/cookies';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
      meta: { title: '润泽水驿', hidden: true, notNeedAuth: true }
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { title: '润泽水驿', hidden: true, notNeedAuth: true }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/store',
      children: [
        {
          path: 'store',
          component: () =>
            import(/* webpackChunkName: "store" */ '@/views/store/index.vue'),
          meta: {
            title: '商户管理',
            icon: 'icon-shop',
            menuGroup: 'root',
            permission: 'store:list'
          }
        },
        {
          path: 'dashboard',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
          name: 'Dashboard',
          meta: {
            title: '工作台',
            icon: 'dashboard',
            affix: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: 'dashboard:view'
          }
        },
        {
          path: '/statistics',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/statistics/index.vue'),
          meta: {
            title: '数据统计',
            icon: 'icon-statistics',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'statistics:view'
          }
        },
        {
          path: 'user',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/user/index.vue'),
          meta: {
            title: '用户管理',
            icon: 'icon-employee',
            // 列表按当前店铺隔离，须先选店再进（否则不发请求）
            requiresStore: true,
            menuGroup: 'store',
            permission: 'user:list'
          }
        },
        {
          path: 'order',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/orderDetails/index.vue'),
          meta: {
            title: '订单管理',
            icon: 'icon-order',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'order:list'
          }
        },
        {
          path: 'courierAssign',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/courierAssign/index.vue'),
          meta: {
            title: '派送记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'courierAssign:list'
          }
        },
        {
          path: 'category',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/category/index.vue'),
          meta: {
            title: '分类管理',
            icon: 'icon-category',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'category:list'
          }
        },
        {
          path: 'dish',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/dish/index.vue'),
          meta: {
            title: '商品管理',
            icon: 'icon-dish',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'dish:list'
          }
        },
        {
          path: 'purchaseNotice',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/purchaseNotice/index.vue'),
          meta: {
            title: '购买须知',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'purchaseNotice:list'
          }
        },
        {
          path: 'homeBanner',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/homeBanner/index.vue'),
          meta: {
            title: '首页轮播',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'homeBanner:list'
          }
        },
        {
          path: '/dish/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/dish/addDishtype.vue'),
          meta: {
            title: '添加商品',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: ['dish:create', 'dish:update']
          }
        },
        {
          path: 'setmeal',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/setmeal/index.vue'),
          meta: {
            title: '特惠套餐',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'setmeal:list'
          }
        },
        {
          path: 'coupon',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/coupon/index.vue'),
          meta: {
            title: '优惠券管理',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: 'coupon:list'
          }
        },
        {
          path: 'userCoupon',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/userCoupon/index.vue'),
          meta: {
            title: '优惠券发放记录',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: 'userCoupon:list'
          }
        },
        {
          path: 'rechargeRule',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/rechargeRule/index.vue'),
          meta: {
            title: '充值规则管理',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: 'rechargeRule:list'
          }
        },
        {
          path: 'inviteReward',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/inviteReward/index.vue'),
          meta: {
            title: '邀请返余额',
            icon: 'icon-combo',
            // 每桶 2 元已写死后端，配置页隐藏；保留路由以免旧书签报错
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: 'inviteReward:list'
          }
        },
        {
          path: 'waterVoucher',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/waterVoucher/index.vue'),
          meta: {
            title: '实惠套餐商品',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'waterVoucher:list'
          }
        },
        {
          path: 'bucketGiftTier',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/bucketGiftTier/index.vue'),
          meta: {
            title: '套餐赠送档位',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'bucketGiftTier:list'
          }
        },
        {
          path: 'inviteRewardLog',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/inviteReward/log.vue'),
          meta: {
            title: '邀请返现记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'inviteRewardLog:list'
          }
        },
        {
          path: 'waterVoucherPurchase',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/waterVoucherPurchase/index.vue'),
          meta: {
            title: '套餐购买记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'waterVoucherPurchase:list'
          }
        },
        {
          path: 'userWaterQuota',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/userWaterQuota/index.vue'),
          meta: {
            title: '剩余套餐数量',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'userWaterQuota:list'
          }
        },
        {
          path: 'waterBucketUse',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/waterBucketUse/index.vue'),
          meta: {
            title: '额度抵扣记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'waterBucketUse:list'
          }
        },
        {
          path: 'emptyBucketRecord',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/emptyBucketRecord/index.vue'),
          meta: {
            title: '空桶配送/回收记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'emptyBucketRecord:list'
          }
        },
        {
          path: 'emptyBucketRefund',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/emptyBucketRefund/index.vue'),
          meta: {
            title: '退桶退押金申请',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'emptyBucketRefund:list'
          }
        },
        {
          path: 'walletRecord',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/walletRecord/index.vue'),
          meta: {
            title: '充值记录',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: 'walletRecord:list'
          }
        },
        {
          path: 'employee',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/employee/index.vue'),
          meta: {
            title: '人员管理',
            icon: 'icon-employee',
            requiresStore: false,
            menuGroup: 'root',
            permission: 'employee:list'
          }
        },
        {
          path: 'rolePermission',
          component: () =>
            import(/* webpackChunkName: "rolePermission" */ '@/views/rolePermission/index.vue'),
          meta: {
            title: '角色管理',
            icon: 'icon-employee',
            requiresStore: false,
            menuGroup: 'root',
            permission: 'permission:config'
          }
        },
        {
          path: 'operationLog',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/operationLog/index.vue'),
          meta: {
            title: '操作日志',
            icon: 'icon-employee',
            requiresStore: false,
            menuGroup: 'root',
            permission: 'operationLog:list'
          }
        },

        {
          path: '/employee/add',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/employee/addEmployee.vue'),
          meta: {
            title: '添加人员',
            hidden: true,
            requiresStore: false,
            menuGroup: 'root',
            permission: ['employee:create', 'employee:update']
          }
        },

        {
          path: '/setmeal/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/setmeal/addSetmeal.vue'),
          meta: {
            title: '编辑特惠套餐',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store',
            permission: ['setmeal:create', 'setmeal:update']
          }
        },

        {
          path: 'inform',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/inform/index.vue'),
          meta: {
            title: '通知中心',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'inform:list'
          }
        },
        {
          path: 'notice',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/notice/index.vue'),
          meta: {
            title: '广告弹窗',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store',
            permission: 'notice:list'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
});

export default router;
